import { render } from "./OvRejectModal.vue?vue&type=template&id=7edd0331"
import script from "./OvRejectModal.vue?vue&type=script&lang=js"
export * from "./OvRejectModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__